import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "10",
  height: "10",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M0 7.533v1.6c0 .5.367.867.867.867h1.6a.84.84 0 0 0 .866-.867V7.867c0-.667.534-1.2 1.2-1.2H5.8a.84.84 0 0 0 .867-.867V4.533c0-.666.533-1.2 1.2-1.2h1.266A.84.84 0 0 0 10 2.467v-1.6A.84.84 0 0 0 9.133 0h-1.6a.84.84 0 0 0-.866.867v1.266c0 .667-.534 1.2-1.2 1.2H4.2a.84.84 0 0 0-.867.867v1.267c0 .666-.533 1.2-1.2 1.2H.867A.84.84 0 0 0 0 7.533"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M2.467 0h-1.6A.84.84 0 0 0 0 .867v1.6c0 .5.367.866.867.866h1.266c.667 0 1.2.534 1.2 1.2V5.8c0 .5.367.867.867.867h1.267c.666 0 1.2.533 1.2 1.2v1.266c0 .5.366.867.866.867h1.6A.84.84 0 0 0 10 9.133v-1.6a.84.84 0 0 0-.867-.866H7.867c-.667 0-1.2-.534-1.2-1.2V4.2a.84.84 0 0 0-.867-.867H4.533c-.666 0-1.2-.533-1.2-1.2V.867A.84.84 0 0 0 2.467 0"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }